export const GEAR_NOTIFICATION_TYPE = {
  NONE: 'none',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
} as const;

export type GearNotificationType = (typeof GEAR_NOTIFICATION_TYPE)[keyof typeof GEAR_NOTIFICATION_TYPE];
